
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.493 21.501a.502.502 0 01-.487-.422L9.348 4.247l-2.369 7.898a.503.503 0 01-.479.356h-6a.5.5 0 010-1h5.628l2.893-9.644a.5.5 0 01.974.066l2.581 16.344 2.437-11.371a.495.495 0 01.489-.395c.208 0 .386.12.464.314l1.874 4.686h5.66a.5.5 0 010 1h-6a.496.496 0 01-.464-.314L15.645 8.71l-2.656 12.396a.502.502 0 01-.489.395h-.007z"}})])
          )
        }
      }
    